export default __webpack_public_path__ + "static/promo_2-dc854880bb2fc7a8bc9915d675a93ca5.webp";